import { ActionTypes } from "../constants/action-types";

const initialState = {
    encouragementShown: {} as { [popoverId: string]: boolean },
    eventPopoverIds: {} as { [event: string]: string[] },
};

export function encouragementReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_ENCOURAGEMENT_EVENT_POPOVER_IDS:
            return {
                ...state,
                eventPopoverIds: payload || {},
            };

        case ActionTypes.SET_ENCOURAGEMENT_SHOWN:
            return {
                ...state,
                encouragementShown: {
                    ...state.encouragementShown,
                    [payload]: true,
                },
            };

        case ActionTypes.SET_ENCOURAGEMENT_SHOWN_BULK:
            return {
                ...state,
                encouragementShown: {
                    ...state.encouragementShown,
                    ...(payload || {}),
                },
            };

        case ActionTypes.RESET_ENCOURAGEMENT:
            return {
                ...state,
                encouragementShown: {},
                eventPopoverIds: {},
            };

        default:
            return state;
            
    }
}